import { useEffect, useState } from "react"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

import { MiniEditor } from "./mini-editor"

type EditorModalProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  content: string
  placeholder?: string
  onSave: (html: string) => void
}

export function EditorModal({
  open,
  onOpenChange,
  title,
  content,
  placeholder,
  onSave,
}: EditorModalProps) {
  const [draft, setDraft] = useState(content)

  // Reset draft whenever the modal opens or content changes while open
  useEffect(() => {
    if (open) setDraft(content)
  }, [open, content])

  const handleSave = () => {
    onSave(draft)
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <MiniEditor
            className="min-h-[200px]"
            content={draft}
            placeholder={placeholder}
            onChange={setDraft}
          />
        </DialogBody>
        <DialogFooter>
          <Button size="sm" variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button size="sm" onClick={handleSave}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
